import { useCheckEditTemplatedCampaignPermission } from 'hooks/permissions'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectCampaignByTemplateData } from 'state'

interface TemplateInputFieldContainerProps {
    checkForLiveEditBriefAndDeadline?: boolean // Add this prop if need to check live campaign permission
    launchFieldEditable?: boolean
}

const TemplateInputFieldContainer: React.FC<TemplateInputFieldContainerProps> = ({
    children,
    checkForLiveEditBriefAndDeadline = false,
    launchFieldEditable = false,
}) => {
    const campaign = useSelector(selectCampaignByTemplateData)

    const isPermissionEditable = useCheckEditTemplatedCampaignPermission(
        (campaign && campaign.status) || undefined,
        checkForLiveEditBriefAndDeadline,
        launchFieldEditable,
    )

    const isReadOnly = !isPermissionEditable

    return (
        <>
            {typeof children === 'function'
                ? children(isReadOnly)
                : React.Children.map(children, (child: any) => {
                      const { isReadOnly: childIsReadyOnly } = child.props
                      return React.cloneElement(child, {
                          isReadOnly: childIsReadyOnly !== undefined ? childIsReadyOnly : isReadOnly,
                      })
                  })}
        </>
    )
}

export default TemplateInputFieldContainer
